import { ProductModel, ProductCodes } from '../../models/user-profile.model';

export interface UserSessionState {
  isInitializing: boolean;
  isLoggedIn: boolean;
  isLoading: boolean;
  pairedProducts: Partial<Record<ProductCodes, ProductModel>>;
  unpairedProducts: Partial<Record<ProductCodes, ProductModel>>;
  alertMessage?: string;
  successMessage?: string;
  hasError?: boolean;
  name?: string;
  displayName?: string;
  email?: string;
  pairingToken?: string;
  createUserErrors?: CreateUserErrors;
}

export const initialUserSessionState: UserSessionState = {
  isInitializing: true,
  isLoggedIn: false,
  isLoading: false,
  pairedProducts: {},
  unpairedProducts: {},
};

export interface CreateUserErrors {
  username?: string;
  email?: string;
  password?: string;
  token?: string;
  status?: number;
}
